import {ClassName} from '#/utils/utils';
import {FunctionComponent} from 'react';
import {OpenGraphLink} from 'shareland-common';

type LinkOpenGraphProps = {openGraphLink: OpenGraphLink} & ClassName;

export const LinkOpenGraph: FunctionComponent<LinkOpenGraphProps> = ({openGraphLink, className = ''}) => {
  const href = `https://${openGraphLink.url}`;
  return (
    <a href={href} className={`w-full flex gap-4 hover:opacity-70 ${className}`} target='_blank' rel='noreferrer'>
      <div className='w-1 bg-gray-400 rounded overflow-hidden' />

      <div className='flex-1 text-xs text-white space-y-2 overflow-hidden'>
        <span className='block font-bold text-gray-300'>{openGraphLink.hostName}</span>

        {openGraphLink.title ? (
          <>
            <span className='block text-deepblue font-bold'>{openGraphLink.title}</span>
            {openGraphLink.description && <span className='block text-gray-300'>{openGraphLink.description}</span>}
          </>
        ) : (
          <>
            <span className='block truncate text-deepblue font-bold'>{openGraphLink.url}</span>
          </>
        )}

        {openGraphLink.imageUrl && (
          <img
            src={openGraphLink.imageUrl}
            alt={openGraphLink.description ?? ''}
            className='block w-full aspect-video object-cover rounded-xl overflow-hidden mt-2'
          />
        )}
      </div>
    </a>
  );
};

export const LinkOpenGraphLoading: FunctionComponent<ClassName> = ({className = ''}) => {
  return (
    <div className={`w-full flex gap-4 animate-pulse duration-100 ${className}`}>
      <div className='w-1 bg-gray-400 rounded overflow-hidden' />

      <div className='flex-1 text-xs text-white space-y-3 overflow-hidden'>
        <span className='block h-3 w-1/3 bg-gray-300 rounded' />
        <span className='block h-3 w-4/6 bg-gray-300 rounded' />
        <span className='block h-3 w-5/6 bg-gray-300 rounded' />

        <div className='block w-full aspect-video bg-gray-300  rounded-xl overflow-hidden mt-2' />
      </div>
    </div>
  );
};
